<script>
export default {
  asyncData({ redirect }) {
    return redirect(301, '/faq/list')
  }
}
</script>
